import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './verifyRegistrationOtpPage.css';
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useUser } from '../../contexts/userContext';
import { useExchangeUser } from '../../contexts/userExchangeProgramContext';
// import '../home/homePage.css';

const VerifyRegistrationOtp = () => {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [error, setError] = useState('');
    const [seconds, setSeconds] = useState(60);
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const userId = location.state?.user_id;
    let returnUrl = location.state?.returnUrl;
    const product = location.state?.product;
    const userInfo = location.state?.user;
    const cartId = location.state?.cart_id;
    const session_code = location.state?.session_code;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    // const { auth_token } = useUser();
    const otpInputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const { auth_token, cust_info, order_id, user_id,fetchCsrfToken } = useExchangeUser();

    // Set focus on the first input box when the component mounts
    useEffect(() => {
        otpInputRefs.current[0]?.focus();
    }, []);

    // Handle OTP input change
    const handleChange = (element: any, index: any) => {
        const value = element.value.replace(/\D/g, '');
        if (value.length === 1) { // Ensure only one digit is entered
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Focus on the next input if the current input has a value
            if (element.nextSibling) {
                element.nextSibling.focus();
            }
        }
    };

    // Handle backspace key
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace') {
            const newOtp = [...otp];
            newOtp[index] = ''; // Clear current input
            setOtp(newOtp);

            // Move to previous input
            if (index > 0) {
                const prevInput = document.querySelectorAll('.otp-input')[index - 1] as HTMLInputElement;
                prevInput?.focus();
            }
        }
    };

    // Handle resend OTP
    const handleResendOtp = async () => {
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v1/resend-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${auth_token}`,
                    'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ userInfo }),
            });

            if (!response.ok) {
                throw new Error('Failed to resend OTP');
            }

            //console.log('OTP resent successfully');
            setSeconds(60); // Reset timer
            setIsDisabled(true); // Disable resend button
        } catch (error) {
            //console.error('Error resending OTP:', error);
        }
    };

    // Timer logic
    useEffect(() => {
        if (isDisabled && seconds > 0) {
            const timer = setInterval(() => {
                setSeconds(prev => prev - 1);
            }, 1000);
    
            // Clear interval on component unmount or when seconds reach zero
            return () => clearInterval(timer);
        } else if (seconds <= 0) {
            setIsDisabled(false); // Enable resend button when timer is up
            setSeconds(60); // Reset the timer value
        }
    }, [seconds, isDisabled]);

    // Automatically submit OTP when all fields are filled
    useEffect(() => {
        if (otp.join('').length === otp.length) {
            handleOtpSubmit();
        }
    }, [otp]);

    const handleOtpSubmit = async () => {
        if (!userId) {
            setError('User ID is missing.');
            return;
        }

        const otpValue = otp.join(''); // Join the OTP array into a single string

        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v1/verify-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${auth_token}`,
                    'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ userId, otp: otpValue }),
            });

            const data = await response.json();

            if (data.data.success) {
                localStorage.setItem('isLoggedIn', 'true'); // Set login state
                if(returnUrl == '/cart' || returnUrl == '/sell-used-appliances' ){
                    returnUrl='/order-summary'
                   }
                   navigate(returnUrl || "/", {
                       state: { user_id: userId, returnUrl, product,cart_id: cartId, session_code: session_code }
                   });
            } else {
                setError(data.error?.message || 'OTP verification failed');
            }
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div>
            <Header />
            <main className="main-content-verify">
                <div className="verify-otp-content">
                    <p className='heading-otp'>Enter Verification OTP</p>
                    <ul className="proDetailsProcess-verify-registration">
                        <li className="numOne active done">
                            <div className="progNum"></div>
                            <div className="detailsSteps">Enter details</div>
                        </li>
                        <li className="numTwo">
                            <div className="progNum"></div>
                            <div className="detailsSteps">Verify OTP</div>
                        </li>
                    </ul>
                    <div className='verify-rep'>
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                type="text"
                                className="otp-input"
                                maxLength={1}
                                value={digit}
                                placeholder='__'
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onFocus={(e) => e.target.select()}
                                ref={(el) => otpInputRefs.current[index] = el}
                            />
                        ))}
                    </div>
                    <div className="otptext">
                        <p className="info">An OTP has been sent to your Mobile No.</p>
                        <p className="request">
                            {isDisabled ? `Request new OTP in ${seconds}s` : 'You can request a new OTP'}
                        </p>
                    </div>
                    <div
                        className="linkResendotp"
                        onClick={handleResendOtp}
                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                    >
                        RESEND OTP
                    </div>
                    {error && <p className="error">{error}</p>}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default VerifyRegistrationOtp;
